import TopPageCMSBannerMessage from 'components/RwdBasket/RwdBasketLayout/TopContentMessages/TopPageCMSBannerMessage/TopPageCMSBannerMessage';

export default TopPageCMSBannerMessage;
